/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spelling_Numbers_CompleteInputs */



/**
* | output |
* | --- |
* | "Spelling numbers #0-10 complete" |
*
* @param {Spelling_Numbers_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spelling_numbers_complete = /** @type {((inputs?: Spelling_Numbers_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spelling_Numbers_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épellation des chiffres #0-10 terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Buchstabieren der Zahlen 0-10 vollständig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completamento dell'ortografia dei numeri da 0 a 10")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Написание цифр от 0 до 10 завершено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deletrear números del 0 al 10 completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拼写数字 #0-10 完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("数字のスペリング #0-10 完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संख्या 0-10 की वर्तनी पूरी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escreva os números de 0 a 10 por extenso.")
	return /** @type {LocalizedString} */ ("Spelling numbers #0-10 complete")
});